import React, { useEffect, useLayoutEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { BiPencil } from "react-icons/bi";
import {
  getTables,
  RESET_TABLE,
  selectTables,
  selectTableSuccess,
  updateTable,
} from "../../redux/features/table/TableSlice";

const EditTable = ({ id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tableName, setTableName] = useState("");
  const [personSpace, setPersonSpace] = useState("");
  const [tableStatus, setTableStatus] = useState("");

  const [errors, setErrors] = useState({});

  const tables = useSelector(selectTables);
  const table = tables.find((table) => table._id === id);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => {
    setIsOpen(false);
    setErrors({});
  };

  useLayoutEffect(() => {
    if (table) {
      setTableName(table.tableNo);
      setTableStatus(table.tableStatus);
      setPersonSpace(table.personSpace);
    }
  }, [table]);

  const validateForm = () => {
    const newErrors = {};
    if (!tableName) newErrors.tableName = "Table name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const dispatch = useDispatch();
  const isSuccess = useSelector(selectTableSuccess);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const updateTableDate = {
      id,
      tableNo: tableName,
      personSpace: Number(personSpace),
      tableStatus,
    };

    await dispatch(updateTable(updateTableDate));
    dispatch(getTables());
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose();
      dispatch(RESET_TABLE());
    }
  }, [isSuccess, dispatch]);

  return (
    <div>
      {/* Button to open the modal */}
      <button
        onClick={handleOpen}
        className="absolute text-white bg-[#20BEC6CC] rounded-lg p-[4px] top-3 right-3"
      >
        <BiPencil className="size-4" />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] md:w-[650px] w-[90%] mx-auto p-10 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-4 mb-6">
              <h1 className="md:text-[1.75rem] text-[1rem] font-bold text-[#0D868C]">
                Update Table
              </h1>
              <button type="button" onClick={handleClose}>
                <FiX className="md:size-8 size-5 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Table Name
                </label>
                <input
                  value={tableName}
                  onChange={(e) => setTableName(e.target.value)}
                  type="text"
                  placeholder="Table name GF-1 etc."
                  className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.tableName && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.tableName}
                  </p>
                )}
              </div>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Person Space
                </label>
                <input
                  value={personSpace}
                  onChange={(e) => setPersonSpace(e.target.value)}
                  type="number"
                  min={0}
                  step={1}
                  onWheel={(e) => e.target.blur()}
                  placeholder="Person Space 4 etc."
                  className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
              </div>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Table Status
                </label>
                <select
                  value={tableStatus}
                  onChange={(e) => setTableStatus(e.target.value)}
                  className="w-full outline-none rounded-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] capitalize"
                >
                  <option value="outOfService" className="capitalize">
                    out Of Service
                  </option>
                  <option value="vacant" className="capitalize">
                    vacant
                  </option>
                  <option value="occupied" className="capitalize">
                    occupied
                  </option>
                </select>
              </div>

              <div className="text-center mt-8">
                <button
                  type="submit"
                  className="text-white bg-[#0D868C] w-[50%] py-3 rounded-full outline-none uppercase font-normal text-[1rem]"
                >
                  Update Table
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditTable;
